import React from 'react';
import { Button } from 'components/ui/button';
import { STEP_LABELS } from '../../constants';

interface HoraCertaFileStepProps {
  inputRef: React.RefObject<HTMLInputElement>;
  onFileSelect: (file: File) => void;
}

export const HoraCertaFileStep = ({
  inputRef,
  onFileSelect,
}: HoraCertaFileStepProps) => (
  <div className="mt-6 grid grid-cols-1 lg:grid-cols-3 gap-6">
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6 flex flex-col">
      <h2 className="font-GilroySemibold text-base text-slate-800 mb-4">
        Selecionar arquivo
      </h2>
      <div
        role="button"
        tabIndex={0}
        onClick={() => inputRef.current?.click()}
        onKeyDown={(event) => event.key === 'Enter' && inputRef.current?.click()}
        className="flex-1 border-2 border-dashed border-slate-300 rounded-xl p-8 flex flex-col items-center justify-center text-center cursor-pointer hover:border-[#EE7C2C]/60 transition-colors"
      >
        <p className="text-sm text-slate-600 max-w-[220px]">
          Selecione um arquivo .xlsx para iniciar a pré-visualização.
        </p>
      </div>
      <a
        href="/templates/template-hora-certa.xlsx"
        download
        className="mt-4 text-center text-xs font-semibold text-[#EE7C2C] hover:underline"
      >
        Baixar planilha modelo
      </a>
      <Button
        type="button"
        className="mt-3 bg-[#EE7C2C] hover:bg-[#d4691f] text-white"
        onClick={() => inputRef.current?.click()}
      >
        Selecionar planilha
      </Button>
      <input
        ref={inputRef}
        type="file"
        accept=".xlsx"
        aria-label="Selecionar planilha"
        className="hidden"
        onChange={(event) => {
          const selected = event.target.files?.[0];
          if (selected) onFileSelect(selected);
          event.target.value = '';
        }}
      />
    </div>

    <div className="lg:col-span-2 bg-white rounded-xl border border-blue-100 shadow-sm p-6">
      <h2 className="font-GilroySemibold text-base text-slate-900 mb-1">
        Fluxo do Processo de Importação
      </h2>
      <p className="text-xs text-slate-500 mb-4">
        Acompanhe as 4 etapas para integrar os registros do Hora Certa.
      </p>
      <ol className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {STEP_LABELS.map((label, index) => (
          <li
            key={label}
            className="bg-slate-50 border border-slate-100 rounded-lg p-4"
          >
            <span className="inline-flex w-6 h-6 rounded-lg bg-[#EE7C2C] text-white items-center justify-center text-xs font-bold mr-2">
              {index + 1}
            </span>
            <span className="text-sm font-semibold text-slate-800">
              {label}
            </span>
          </li>
        ))}
      </ol>
    </div>
  </div>
);
